'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.makeBatchSaga = makeBatchSaga;

var _fsa = require('@zaibot/fsa');

var _fsaSaga = require('@zaibot/fsa-saga');

var _effects = require('redux-saga/effects');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stopMiddleware(descriptor, options) {
    return function* (action, next) {};
}
function resourceUpdate(descriptor, options) {
    return function* (action, next) {
        if ((0, _fsa.isType)(action, descriptor.actions.UPDATE)) {
            let item = descriptor.merger.combine(action.payload.items);
            yield (0, _effects.put)(descriptor.actions.APPLY({ item: item }));
        }
        yield* next(action);
    };
}
function resourceUpdateContinueImmediately(descriptor, options) {
    return function* (action, next) {
        if ((0, _fsa.isType)(action, descriptor.actions.UPDATE_CONTINUE)) {
            let items = descriptor.merger.merge(action.payload.item, action.payload.items);
            for (let i = 0, ii = items.length; i < ii; i++) {
                yield (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: items[i] }));
            }
        }
        yield* next(action);
    };
}
function resourceUpdateContinueDelayed(descriptor, options) {
    return function* (action, next) {
        if ((0, _fsa.isType)(action, descriptor.actions.UPDATE_CONTINUE)) {
            let items = descriptor.merger.merge(action.payload.item, action.payload.items);
            for (let i = 0, ii = items.length; i < ii; i++) {
                let storeItem = yield (0, _effects.select)(descriptor.resource.selectors.itemByItem(items[i]));
                if (storeItem && descriptor.resource.fields.hasCommited(storeItem)) {
                    yield (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: items[i] }));
                } else {
                    yield (0, _effects.put)(descriptor.resource.actions.CREATE({ item: items[i] }));
                }
            }
        }
        yield* next(action);
    };
}
function resourceDelete(descriptor, options) {
    return function* (action, next) {
        if ((0, _fsa.isType)(action, descriptor.actions.DELETE)) {
            let item = descriptor.merger.combine(action.payload.items);
            yield (0, _effects.put)(descriptor.actions.APPLY({ item: item }));
        }
        yield* next(action);
    };
}
function resourceDeleteContinue(descriptor, options) {
    return function* (action, next) {
        if ((0, _fsa.isType)(action, descriptor.actions.DELETE_CONTINUE)) {
            let items = action.payload.items;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    let item = _step.value;

                    yield (0, _effects.put)(descriptor.resource.actions.DELETE({ item: item }));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        yield* next(action);
    };
}
function makeBatchSaga(descriptor, options, middlewares) {
    let resource = descriptor.resource;

    let actions = [...descriptor.actions.all, ...resource.actions.all];
    let wares = [...middlewares, resourceUpdate, options.createImmediately ? resourceUpdateContinueImmediately : resourceUpdateContinueDelayed, resourceDelete, resourceDeleteContinue, stopMiddleware];
    let compiled = wares.map(mw => mw(descriptor, options));
    let f = (0, _utils.applyMiddlewares)(...compiled);
    return function* internal() {
        yield (0, _fsaSaga.takeEvery)(actions, f);
    };
}
//# sourceMappingURL=makeBatchSaga.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/batch/makeBatchSaga.js